import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const CardListing = (props: any) => {
  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Heading */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800">
            {props.title}
          </h2>
          <p className="text-gray-600 mt-3 text-lg max-w-2xl mx-auto">
            {props.description}
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {props.list.map((srv: any, index: number) => (
            <motion.div
              key={srv.id}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="
    relative group bg-white rounded-xl shadow-md overflow-hidden cursor-pointer
     transition-all duration-500
  "
            >
              {/* Image */}
              <div className="h-64 overflow-hidden">
                <img
                  src={srv.img}
                  alt={srv.title}
                  className="
        w-full h-full object-cover 
        group-hover:scale-110 
        transition-all duration-700
      "
                />
              </div>

              {/* Title + Tagline */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {srv.title}
                </h3>

                {/* Tagline */}
                <p className="text-gray-500 text-sm">{srv.tagline}</p>
              </div>

              {/* Hover Content (Slide-up + Grey Background) */}
              <div
                className="
      absolute inset-0 
      bg-gray-100/95 backdrop-blur-sm 
      p-7 flex flex-col justify-center 
      translate-y-full group-hover:translate-y-0 
      transition-all duration-700 ease-out
      shadow-inner
    "
              >
                <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
                  {srv.title}
                </h3>

                <p className="text-gray-700 mb-6">{srv.description}</p>

                <Link
                to={`/detail-page?key=${srv.ctaUrl}`}
                  className="
        px-5 py-3 bg-red-600 text-white font-semibold 
        rounded-lg hover:bg-red-700 transition
      "
                >
                  {srv.ctaText} →
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
